import { useEffect } from 'react'
import { useParams } from 'react-router-dom'

import { useRoutes } from 'app/use_routes'
import { areAllGroomingOffersUnavailable, areAllOffersUnavailable } from 'components-ui/src/offer_card/helper'
import type { BookingSearchByDaysClientDto, BookingSearchClientDto } from 'service-api/src/types/api'

/**
 * Redirects the pet owner to the "Contact Us To Book" page when a completed
 * offers search returned results but none of them are actionable (cannot be
 * booked, temper-test scheduled, or waitlisted). For grooming, results are
 * actionable when a groom offer has at least one available day/slot.
 */
export const useRedirectAllOffersUnavailable = ({
  offers,
  isSuccess,
  isEnabled = true,
  petGroup = 0,
  waitlistEnabled = false,
}: {
  offers: (BookingSearchClientDto | BookingSearchByDaysClientDto)[] | undefined
  isSuccess: boolean
  isEnabled?: boolean
  petGroup?: number
  waitlistEnabled?: boolean
}) => {
  const { serviceTypeName = '' } = useParams()
  const { navigateRoute } = useRoutes()

  useEffect(() => {
    if (!isEnabled || !isSuccess) return

    const allUnavailable =
      serviceTypeName === 'grooming'
        ? areAllGroomingOffersUnavailable(offers as BookingSearchByDaysClientDto[] | undefined)
        : areAllOffersUnavailable(offers, serviceTypeName, petGroup, { waitlistEnabled })

    if (allUnavailable) {
      navigateRoute('contactToBook', { serviceTypeName }, { replace: true })
    }
  }, [isEnabled, isSuccess, offers, serviceTypeName, petGroup, waitlistEnabled, navigateRoute])
}
